module.exports = __webpack_public_path__ + "img/W-3.2fbab75e.jpg";